<template>
  <v-menu>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon small>
        <v-icon small>fa-ellipsis-v</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-subheader>Exibir itens</v-subheader>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        @click="() => handleFilterOptionsChange(item.value)"
      >
        <v-list-item-icon class="mr-4">
          <v-icon
            v-show="selectedFaturamentoItensFilterOption === item.value"
            small
          >
            fa-check
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      items: [
        { title: 'Itens não conciliados', value: 'nao-conciliados' },
        { title: 'Itens conciliados', value: 'conciliados' },
        { title: 'Todos os itens', value: 'todos' }
      ]
    }
  },
  computed: {
    ...mapState('conciliacao', ['selectedFaturamentoItensFilterOption'])
  },
  methods: {
    handleFilterOptionsChange (filterOption) {
      this.$store.dispatch('conciliacao/setSelectedFaturamentoItensFilterOption', filterOption)
    }
  }
}
</script>
